/* eslint-disable no-useless-escape */
import _ from 'lodash';

const helpers = {
  compareArraysByFiled(firstArray, secondArray, field) {
    if (firstArray.length === 0 || firstArray.length !== secondArray.length) {
      return false;
    }

    const comparator = (item, index) => item[field] !== secondArray[index][field];

    return _.filter(firstArray, comparator).length === 0;
  },
  validateName(userName) {
    const ruleExp = new RegExp("[<\>]+");

    return userName.trim().length && !ruleExp.test(userName.trim());
  },
  validateColumnName(name) {
    const ruleExp = new RegExp("[<\>]+");

    return !ruleExp.test(name.trim());
  },
  validateTaskName(userName) {
    return userName.trim().length;
  },
  validateNameInGrid(name) {
    const ruleExp = new RegExp("[<\>]+");

    return !ruleExp.test(name.trim());
  },
  validateEmail(email) {
    const ruleExp = new RegExp("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$");

    return ruleExp.test(email.trim());
  },
  getFileNameWithoutExt(fileName) {
    const ruleExp = new RegExp("(.+?)(\.[^.]*$|$)");

    return ruleExp.exec(fileName)[1];
  },
  isMySelf(targetUserId) {
    return parseInt(targetUserId, 10) === parseInt(user.id, 10);
  },
  isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  },
  testNumber(value) {
    return /^(\d+[.,]?\d{0,9}|[.,]\d{1,9})$/.test(value);
  },
  sanitizeText(value) {
    return value.replace(/ +(?= )/g, '').replace(/>/g, "&gt;").replace(/</g, "&lt;");
  },
  removeSpaces(value) {
    return value.replace(/ +(?= )/g, '').trim();
  },
  formatTaskName(value) {
    if (!value) {
      return value;
    }

    return value.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  },
  formatLocaleText(value) {
    if (!value) {
      return value;
    }

    return value.replace(/<b>/g, '#b#')
      .replace(/<\/b>/g, '#/b#')
      .replace(/<strong>/g, '#strong#')
      .replace(/<\/strong>/g, '#/strong#')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replaceAll('#b#', '<b>')
      .replaceAll('#/b#', '</b>')
      .replaceAll('#strong#', '<strong>')
      .replaceAll('#/strong#', '</strong>');
  },
};

export default helpers;
